import React, { createContext, useContext, useReducer } from "react";

// Define initial state
const initialState = {
  user: null,
  authChecked: false,
  isProtectedRoute: false,
};

// Create context
const AppContext = createContext();

// Define reducer
function appReducer(state, action) {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_AUTH_CHECKED":
      return {
        ...state,
        authChecked: action.payload,
      };
    case "SET_ROUTE_PROTECTION":
      if (state.isProtectedRoute === action.payload) {
        return state;
      }
      return {
        ...state,
        isProtectedRoute: action.payload,
      };
    default:
      return state;
  }
}

// Create provider component
export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}

// Custom hook for using the context
export function useAppState() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppState must be used within an AppProvider");
  }
  return context;
}

// Optional: Export actions creators
export const actions = {
  setUser: (user) => ({
    type: "SET_USER",
    payload: user,
  }),
  setAuthChecked: (checked) => ({
    type: "SET_AUTH_CHECKED",
    payload: checked,
  }),
  setRouteProtection: (isProtected) => ({
    type: "SET_ROUTE_PROTECTION",
    payload: isProtected,
  }),
};
